import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getPdfId'
})
export class GetPdfIdPipe implements PipeTransform {
transform(url: string): string {
    return url?.split('/').pop()?.replace(/\.pdf$/i, '') || '';
  }
}
